module.exports = __webpack_public_path__ + "media/142.5cced327.wav";